import {Swiper, Autoplay, EffectFade, Navigation, Pagination, Thumbs} from 'swiper'
import {loadBlockLazyImages} from "../helpers/lazy-load";

let productsSliderBlocks = $('.js-our-manufacturers-block')

if (productsSliderBlocks.length){
    productsSliderBlocks.each(function (){
        let block = $(this)

        let productsSwiper = new Swiper(block.find('.js-our-manufacturers-slider')[0], {
            modules: [Autoplay, EffectFade, Navigation, Pagination],
            loop: true,
            slidesPerView: 1,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            on: {
                slideChange: function (slider) {
                    if (slider.realIndex > 0) {
                        loadBlockLazyImages(productsSliderBlocks)
                    }
                },
            },

        })

    })
}
